<h2 mat-dialog-title>Create New Application</h2>

<mat-dialog-content>
  <form [formGroup]="newApplicationForm" (ngSubmit)="submitRequest()">
    <mat-form-field *ngIf="!disableRenewalButton">
      <mat-label>Application Type</mat-label>
      <mat-select formControlName="type">
        <mat-option>-- None --</mat-option>
        <mat-option *ngIf="applicationTypes.newPrimary === 'Y'" value="New Primary Application">Primary Application</mat-option>
        <mat-option *ngIf="applicationTypes.newSecondary === 'Y'" value="New Secondary Application">Secondary Application</mat-option>
        <mat-option *ngIf="applicationTypes.primaryRenewal === 'Y'" value="Primary Renewal">Primary Renewal</mat-option>
        <mat-option *ngIf="applicationTypes.secondaryRenewal === 'Y'" value="Secondary Renewal">Secondary Renewal</mat-option>
        <mat-option *ngIf="applicationTypes.additionalParameters === 'Y'" value="Additional Parameters">Additional Parameters</mat-option>
        <mat-option *ngIf="applicationTypes.changeName === 'Y'" value="Change of Name">Change of Name</mat-option>
        <mat-option *ngIf="applicationTypes.changeAddress === 'Y'" value="Change Of Address">Change of Address</mat-option>
        <mat-option *ngIf="applicationTypes.changeOwnership === 'Y'" value="Change of Ownership">Change of Ownership</mat-option>
        <mat-option *ngIf="applicationTypes.changePersonnel === 'Y'" value="Change of Key Personnel">Change of Personnel</mat-option>
        <mat-option *ngIf="applicationTypes.withdraw === 'Y'" value="Withdraw Only">Withdraw Only</mat-option>
      </mat-select>
      <mat-error *ngIf="newApplicationForm.get('type').invalid">
        An application type is required
      </mat-error>
    </mat-form-field>
    <h3 *ngIf="disableRenewalButton">Processing....</h3>
  </form>
  <div class="flex flex-col gap-2" *ngIf="applicationTypes.newApplication === 'N'">
    <span class="text-red-400">Sorry you will not be able create a new application at this time.  The reason could be one of the following: </span>
    <span class="p-l-16">a. The application status is 'Incomplete'. Please review the application and submit. </span>
    <span class="p-l-16">b. If you need to edit the current application and the application is locked, please contact the administrator to unlock. </span>
    <span class="p-l-16">c. The ORELAP administator is working on the application or the application has not been approved. </span>
    <span class="text-red-400">* If the above reasons do not apply, please contact the ORELAP Administrator as soon as you can.</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="warn" (click)="cancel()">Cancel</button>
  <button *ngIf="applicationTypes.newApplication !== 'N'" mat-raised-button color="primary" (click)="submitRequest()" cdkFocusInitial  [disabled]="disableRenewalButton">Create</button>
</mat-dialog-actions>
